<template>
  <!--  横向 Item  -->
  <div class="item_div" :style="{'width':(1/item_num)*(100-item_num*2)+'%'}">
    <el-image
      style="width: 100%; height: 20vh"
      :src="image_url"
      fit="cover"/>
    <div class="font_div">
      <!-- <p class="title_div">
        {{ title_txt }}
      </p> -->
      <p class="content_div">
        {{ content_txt }}
      </p>
      <!-- <div class="more_div">
        <label class="more_label">more</label>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'list_item_column',
  props:{
    'item_num':{
      type:String,
      require:false,
      default:1
    },
    'id': {    //详情Id
      type:Number,
      require: true,
      default: 0
    },
    'image_url': {    //图片的地址
      type:String,
      require: false,
      default:''
    },
    'title_txt':{   //标题
      type:String,
      require: false,
      default:'标题'
    },
    'content_txt':{   //简述
      type:String,
      require: false,
      default:'简介'
    },
  },

}
</script>

<style scoped lang="scss">

.item_div{
  background: white;
  cursor: pointer;
  overflow: hidden;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  margin-bottom: 15px;
}

.font_div{
  text-align: left;
  padding: 0px 10px 0px 10px;

}
.title_div{
  font-size: 12px;
  font-weight: 600;
  color: #009CD5;
}
.content_div{
  font-size: 8pt;
  font-weight: 400;
  color: #666666;
  line-height: 15px;
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;-webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.more_label {
  color: #009CD5;
}

.more_div {
  text-align: right;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/list_item_video.vue